"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Vision() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2505" id="the-autolexa-vision" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-[200px] light">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-radial-gradient(circle at 30% 40%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 38px), repeating-radial-gradient(circle at 70% 60%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 52px)"
    }} />

      <div className="relative mx-auto w-full max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={leftRef} className={`lg:col-span-6 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-10 md:mb-14">
              <span className="font-default text-xs md:text-sm font-bold uppercase tracking-[0.2em] pb-1 border-b-2" style={{
              borderColor: "var(--foreground)"
            }}>
                01 / Our Philosophy
              </span>
            </div>

            {}
            <h2 className="font-default font-bold uppercase leading-[0.95] tracking-tight text-[56px] sm:text-[72px] md:text-[96px] lg:text-[120px]">
              <span className="block">Architect</span>
              <span className="block">Of</span>
              <span className="relative inline-block">
                Autonomy
                <span aria-hidden="true" className="absolute left-0 -bottom-2 md:-bottom-3 h-[6px] md:h-[10px]" style={{
                width: "108%",
                backgroundColor: "var(--foreground)"
              }} />
              </span>
            </h2>

            {}
            <div className="mt-12 md:mt-14 max-w-[480px] font-default text-[18px] leading-[1.65] text-foreground/85 space-y-6">
              <p className="relative">
                <span className="font-default font-bold float-left mr-3 leading-[0.85] text-[72px] md:text-[96px]" style={{
                color: "var(--foreground)"
              }}>
                  W
                </span>
                <span className="font-default font-bold uppercase tracking-wide">e engineer</span>{" "}
                the future of business operations. We believe that true efficiency is found at the intersection of human creativity and machine precision.
              </p>
              <p>
                Every workflow we build is designed to eliminate friction, reduce operational overhead, and empower your team to focus on high-value strategy rather than repetitive tasks.
              </p>
              <p>
                This is more than automation. It is a fundamental shift in how your organization scales, powered by intelligent, adaptive digital architecture.
              </p>
            </div>

            {}
            <div className="mt-14 md:mt-16 border-t border-border/40 pt-8 max-w-[520px]">
              <div className="flex flex-col gap-3">
                <span className="font-default text-xs font-bold uppercase tracking-[0.2em] text-foreground/70">
                  Our Commitment
                </span>
                <p className="font-default italic text-[18px] md:text-[20px] leading-snug">
                  &ldquo;If a process can be automated, it should be. We build the systems that make that possible.&rdquo;
                </p>
                <div className="flex items-center gap-3 mt-1">
                  <span aria-hidden="true" className="font-default italic text-2xl" style={{
                  color: "var(--foreground)"
                }}>
                    ~
                  </span>
                  <span className="font-default text-[11px] font-bold uppercase tracking-[0.18em]" style={{
                  color: "var(--foreground)"
                }}>
                    AutolexaAi Team
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-6 relative transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="relative max-w-[88%]">
              <div className="relative shadow-3xl" style={{
              boxShadow: "16px 16px 0 0 var(--shadow-color)"
            }}>
                
              </div>
            </div>

            {}
            

            {}
            <div className="relative lg:ml-20 lg:-mr-16 xl:-mr-24 mt-12">
              <div className="relative" style={{
              boxShadow: "16px 16px 0 0 var(--shadow-color)"
            }}>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}